import { render, staticRenderFns } from "./qwik_adddeliveryagent.vue?vue&type=template&id=fa7b8686&"
import script from "./qwik_adddeliveryagent.vue?vue&type=script&lang=js&"
export * from "./qwik_adddeliveryagent.vue?vue&type=script&lang=js&"
import style0 from "./qwik_adddeliveryagent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./qwik_adddeliveryagent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports